var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0304 0L15.3656 1.66486L7.48344 9.54695L5.37662 7.69059L3.60866 6.14369L0.5 9.69428L2.28269 11.2413L6.05434 14.5415L7.70443 16L9.26613 14.4383L18.6952 5.00922L20.3601 3.34442L17.0304 0Z",
    fill: "#008638"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreenIcon);
export default __webpack_public_path__ + "static/media/checked-green-icon.a82b5af5ae6e7ab87fc5ded4934896a0.svg";
export { ForwardRef as ReactComponent };